import { render } from "./UnitEvaluationReport.vue?vue&type=template&id=1fbca53a&scoped=true"
import script from "./UnitEvaluationReport.vue?vue&type=script&lang=js"
export * from "./UnitEvaluationReport.vue?vue&type=script&lang=js"

import "./UnitEvaluationReport.vue?vue&type=style&index=0&id=1fbca53a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbca53a"]])

export default __exports__